import { useEffect, useState } from "react";
import { ShieldCheck, Users, Dot } from "lucide-react";
import { api } from "@/lib/brands";

// Live, real trust signals. Numbers come straight from the database; if real
// volume is still low we deliberately show a static trust line instead of a
// small (or fake-looking) number.
export default function TrustStrip() {
  const [stats, setStats] = useState(null);
  useEffect(() => {
    let active = true;
    api
      .get("/public-stats")
      .then(({ data }) => active && setStats(data))
      .catch(() => {});
    return () => {
      active = false;
    };
  }, []);

  if (!stats) return null;

  const showCount = stats.helped_this_week >= (stats.threshold ?? 5);

  return (
    <div
      data-testid="trust-strip"
      className="flex flex-wrap items-center gap-x-8 gap-y-3 border-y border-hair py-4 font-mono text-[11px] uppercase tracking-widest text-muted"
    >
      {showCount ? (
        <span className="flex items-center gap-2" data-testid="trust-helped">
          <Users className="h-4 w-4 text-accent" />
          <span className="text-ink">{stats.helped_this_week}</span> people helped this past week
        </span>
      ) : (
        <span className="flex items-center gap-2" data-testid="trust-static">
          <ShieldCheck className="h-4 w-4 text-accent" />
          Independent &amp; verified — we never ask for passwords
        </span>
      )}

      {stats.specialist_online && (
        <span className="flex items-center gap-1.5" data-testid="trust-online">
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent opacity-60" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-accent" />
          </span>
          Specialists available now
        </span>
      )}

      {showCount && stats.resolved_total > 0 && (
        <span className="flex items-center gap-1.5" data-testid="trust-resolved">
          <Dot className="h-4 w-4 text-accent" />
          <span className="text-ink">{stats.resolved_total}</span> issues resolved to date
        </span>
      )}
    </div>
  );
}
